import ProductCURModule from "@/modules/SiteProductCUR";

function SiteProductCreatePage() {
  return <ProductCURModule type="create" />;
}

export default SiteProductCreatePage;
